import { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  FaArrowLeft,
  FaPhone,
  FaEnvelope,
  FaPrint,
  FaMapMarkerAlt,
  FaTag,
  FaCreditCard,
} from "react-icons/fa";
import useAxios from "../api/useAxios";
import logo from "../assets/adana.jpeg";

const OrderView = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const axiosInstance = useAxios();

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchOrder = async () => {
    try {
      const res = await axiosInstance.get(`/orders/${orderId}`);
      console.log("orderID URL:- ",`/orders/${orderId}` );
      setOrder(res.data.data);
      console.log("order response1:- ", res.data.data);
    } catch (error) {
      console.error("Failed to fetch order", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrder();
  }, [orderId]);

  const formatDate = (date) =>
    new Date(date).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  const formatDateForInvoice = (date) =>
    new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

  const openInvoice = () => {
    const rupee = "₹";

    const invoiceHTML = `
<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8" />
<title>Invoice - ${order.orderNumber}</title>

<style>
body {
  font-family: Arial, sans-serif;
  background: #f5f5f5;
  padding: 20px;
}

.invoice-container {
  max-width: 900px;
  margin: auto;
  background: #fff;
  padding: 30px;
  border: 1px solid #ddd;
}

.invoice-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 3px solid #2c3e50;
  padding-bottom: 20px;
  margin-bottom: 30px;
}

.company-logo {
  max-width: 180px;
}

.header-right {
  text-align: right;
}

.header-right h1 {
  margin: 0;
  font-size: 28px;
  color: #2c3e50;
}

.header-right p {
  margin: 2px 0;
  font-size: 14px;
}

.section-title {
  font-weight: bold;
  margin-bottom: 10px;
  border-bottom: 2px solid #ddd;
  padding-bottom: 5px;
}

.details-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  margin-bottom: 30px;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th {
  background: #2c3e50;
  color: #fff;
  padding: 10px;
  font-size: 14px;
}

td {
  border: 1px solid #ddd;
  padding: 10px;
  font-size: 14px;
}

.amount-row {
  background: #f1f3f5;
  font-weight: bold;
}

.total-row {
  background: #e9ecef;
  font-size: 18px;
  font-weight: bold;
}

.footer {
  margin-top: 40px;
  text-align: center;
  font-size: 12px;
  color: #555;
  border-top: 1px solid #ddd;
  padding-top: 15px;
}

.print-btn {
  margin-top: 30px;
  display: block;
  padding: 12px 25px;
  background: #007bff;
  color: #fff;
  border: none;
  font-size: 16px;
  cursor: pointer;
  margin-left: auto;
  margin-right: auto;
}

@media print {
  .print-btn {
    display: none;
  }
}
</style>
</head>

<body>

<div class="invoice-container">
  <div class="invoice-header">
    <img src="${logo}" class="company-logo" />
    <div class="header-right">
      <h1>INVOICE</h1>
      <p><strong>Adana Paints</strong></p>
      <p>Hyderabad, Telangana</p>
      <p>Invoice #: ${order.orderNumber}</p>
      <p>Date: ${formatDateForInvoice(order.orderedAt)}</p>
    </div>
  </div>

  <div class="details-grid">
    <div>
      <div class="section-title">Bill To</div>
      <p><strong>${order.customerName}</strong></p>
      ${order.email ? `<p>${order.email}</p>` : ""}
      ${order.mobileNumber ? `<p>${order.mobileNumber}</p>` : ""}
    </div>

    <div>
      <div class="section-title">Ship To</div>
      ${
        order.address
          ? `
        <p>${order.address.addressLine1}</p>
        ${
          order.address.addressLine2
            ? `<p>${order.address.addressLine2}</p>`
            : ""
        }
        <p>${order.address.city}, ${order.address.state} - ${
              order.address.pincode
            }</p>
        <p>${order.address.country}</p>
      `
          : "<p>No address provided</p>"
      }
    </div>
  </div>

  <table>
    <thead>
      <tr>
        <th>S.No</th>     
        <th>Item</th>
        <th>Colour Code</th>
        <th>Price</th>
        <th>Qty</th>
        <th>Total</th>
      </tr>
    </thead>
    <tbody>
      ${order.items
        .map((item,index) => {
          const total = item.price * item.quantity;
          return `
              <tr>
                <td>${index+1}</td>
                <td>${item.productName}</td>
                <td>${item.colorCode}</td>
                <td>${rupee} ${item.price.toFixed(2)}</td>
                <td>${item.quantity}</td>
                <td>${rupee} ${total.toFixed(2)}</td>
              </tr>
            `;
        })
        .join("")}

      <tr class="amount-row">
        <td colspan="4" align="right">Subtotal</td>
        <td>${rupee} ${(order.totalAmount || order.finalAmount).toFixed(2)}</td>
      </tr>

      <tr class="total-row">
        <td colspan="4" align="right">Total</td>
        <td>${rupee} ${order.finalAmount.toFixed(2)}</td>
      </tr>
    </tbody>
  </table>

  <div class="footer">
    <p><strong>Adana Paints</strong></p>
    <p>Authorized Signatory</p>
    <p>This is a system generated invoice. Signature not required.</p>
  </div>

  <button class="print-btn" onclick="window.print()">Print Invoice</button>
</div>

</body>
</html>
`;

    const invoiceWindow = window.open("", "_blank", "width=900,height=700");
    invoiceWindow.document.write(invoiceHTML);
    invoiceWindow.document.close();
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen font-semibold">
        Loading order details...
      </div>
    );
  }

  if (!order) {
    return <div className="text-center p-10 text-red-600">Order not found</div>;
  }

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-6">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
        <div className="flex items-center gap-4">
          <button
            onClick={() => navigate(-1)}
            className="text-blue-600 hover:text-blue-800 flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-blue-50 transition-colors"
          >
            <FaArrowLeft /> Back to Orders
          </button>
          <h1 className="text-2xl font-bold text-gray-900">
            Order #{order.orderNumber}
          </h1>
        </div>

        <div className="flex gap-3">
          <button
            onClick={openInvoice}
            className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors"
          >
            <FaPrint /> View/Print Invoice
          </button>
        </div>
      </div>

      {/* Main Content Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Left Column - Customer Details & Address */}
        <div className="space-y-6">
          {/* Customer Information Card */}
          <div className="bg-white rounded-xl shadow-md p-6">
            <h2 className="text-xl font-bold text-gray-800 mb-4 pb-3 border-b flex items-center gap-2">
              <FaTag className="text-blue-500" />
              Customer Information
            </h2>

            <div className="space-y-4">
              <div>
                <p className="text-sm text-gray-500">Customer Name</p>
                <p className="font-bold text-lg text-gray-800">
                  {order.customerName}
                </p>
              </div>

              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <div className="p-2 bg-blue-50 rounded-lg mt-1">
                    <FaPhone className="text-blue-600 text-sm" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Mobile Number</p>
                    <p className="font-semibold text-gray-700">
                      {order.customerMobileNumber ||
                        order.mobileNumber ||
                        "Not provided"}
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="p-2 bg-blue-50 rounded-lg mt-1">
                    <FaEnvelope className="text-blue-600 text-sm" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Email Address</p>
                    <p className="font-semibold text-gray-700">
                      {order.customerEmail || order.email || "Not provided"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Delivery Address Card */}
          <div className="bg-white rounded-xl shadow-md p-6">
            <h2 className="text-xl font-bold text-gray-800 mb-4 pb-3 border-b flex items-center gap-2">
              <FaMapMarkerAlt className="text-green-500" />
              Delivery Address
            </h2>

            {order.address ? (
              <div className="space-y-3">
                <div className="space-y-2">
                  <p className="font-semibold text-gray-700">
                    {order.customerName}
                  </p>
                  <div className="text-gray-600 space-y-1 text-sm">
                    <p>{order.address.addressLine1}</p>
                    {order.address.addressLine2 && (
                      <p>{order.address.addressLine2}</p>
                    )}
                    {order.address.landmark && (
                      <p className="text-gray-500">
                        <span className="font-medium">Landmark:</span>{" "}
                        {order.address.landmark}
                      </p>
                    )}
                    <p>
                      {order.address.city}, {order.address.state} -{" "}
                      {order.address.pincode}
                    </p>
                    <p>{order.address.country}</p>
                  </div>
                </div>
              </div>
            ) : (
              <p className="text-gray-500 italic">
                No delivery address provided
              </p>
            )}
          </div>

          {/* Order Summary Card */}
          <div className="bg-white rounded-xl shadow-md p-6">
            <h2 className="text-xl font-bold text-gray-800 mb-4 pb-3 border-b flex items-center gap-2">
              <FaCreditCard className="text-purple-500" />
              Payment Summary
            </h2>

            <div className="space-y-3">
              <div className="flex justify-between">
                <span className="text-gray-600">Payment Method</span>
                <span className="font-semibold">
                  {order.paymentStatus.replaceAll("_", " ")}
                </span>
              </div>

              <div className="flex justify-between">
                <span className="text-gray-600">Order Status</span>
                <span
                  className={`font-semibold ${
                    order.orderStatus === "CONFIRMED"
                      ? "text-green-600"
                      : order.orderStatus === "PENDING"
                      ? "text-yellow-600"
                      : order.orderStatus === "CANCELLED"
                      ? "text-red-600"
                      : "text-blue-600"
                  }`}
                >
                  {order.orderStatus.replaceAll("_", " ")}
                </span>
              </div>

              <div className="flex justify-between">
                <span className="text-gray-600">Order Date</span>
                <span className="font-semibold">
                  {formatDate(order.orderedAt)}
                </span>
              </div>

              <div className="pt-3 mt-3 border-t">
                <div className="flex justify-between text-lg">
                  <span className="font-bold text-gray-800">Final Amount</span>
                  <span className="text-2xl font-bold text-green-600">
                    ₹{order.finalAmount.toFixed(2)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column - Order Items & Details */}
        <div className="lg:col-span-2 space-y-6">
          {/* Order Items Card */}
          <div className="bg-white rounded-xl shadow-md p-6">
            <div className="flex justify-between items-center mb-4 pb-3 border-b">
              <h2 className="text-xl font-bold text-gray-800">
                Order Items ({order.items?.length || 0})
              </h2>
              <div className="text-sm text-gray-500">
                Total:{" "}
                <span className="font-bold text-green-600">
                  ₹{order.finalAmount.toFixed(2)}
                </span>
              </div>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="bg-gray-50">
                    <th className="p-3 text-sm font-semibold text-center text-gray-700">
                      S.No
                    </th>
                    <th className="p-3 text-sm font-semibold text-left text-gray-700">
                      Product
                    </th>
                    <th className="p-3 text-sm font-semibold text-center text-gray-700">
                      Colour Code
                    </th>
                    <th className="p-3 text-sm font-semibold text-center text-gray-700">
                      Price
                    </th>
                    <th className="p-3 text-sm font-semibold text-center text-gray-700">
                      Quantity
                    </th>
                    <th className="p-3 text-sm font-semibold text-center text-gray-700">
                      Total
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {order.items &&
                    order.items.map((item,index) => {
                      const itemTotal = item.price * item.quantity;
                      return (

                        <tr
                          key={item.productId}
                          className="border-b hover:bg-gray-50"
                        >
                          {/* s.no */}
                          <td className="p-3 text-center font-medium text-gray-700">
                            {index+1}
                          </td>
                          <td className="p-3">
                            <div className="flex items-center gap-3">
                              <img
                                src={`https://api.adanapaints.com/uploads/brands/${item.productImage}`}
                                alt={item.productName}
                                className="w-12 h-12 rounded-lg object-cover border"
                                onError={(e) => {
                                  e.target.src =
                                    "https://via.placeholder.com/48x48?text=No+Image";
                                }}
                              />
                              <div>
                                <p className="font-medium text-gray-800">
                                  {item.productName}
                                </p>
                                <p className="text-xs text-gray-500">
                                  SKU: {item.productId}
                                </p>
                              </div>
                            </div>
                          </td>
                          <td className="p-3 text-center">
                            <span className="font-semibold">
                                {item.colorCode} 
                            </span>
                          </td>
                          <td className="p-3 text-center">
                            <span className="font-semibold">
                              ₹{item.price.toFixed(2)}
                            </span>
                          </td>
                          <td className="p-3 text-center">
                            <span className="font-semibold">
                              {item.quantity}   
                            </span>
                          </td>
                          <td className="p-3 text-center">
                            <span className="font-semibold text-green-600">
                              ₹{itemTotal.toFixed(2)}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
                <tfoot>
                  <tr className="bg-gray-50">
                    <td
                      colSpan="4"
                      className="p-3 text-right font-semibold text-gray-700"
                    >
                      Subtotal:
                    </td>
                    <td className="p-3 text-center font-bold">
                      ₹{(order.totalAmount || order.finalAmount).toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <td
                      colSpan="4"
                      className="p-3 text-right font-bold text-lg text-gray-800"
                    >
                      Total Amount:
                    </td>
                    <td className="p-3 text-center font-bold text-lg text-green-600">
                      ₹{order.finalAmount.toFixed(2)}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderView;
